var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_check",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1540",
    "data-name": "\\uC0AC\\uAC01\\uD615 1540",
    width: 40,
    height: 40,
    fill: "#23cdb7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_545",
    "data-name": "\\uADF8\\uB8F9 545",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1432",
    "data-name": "\\uD328\\uC2A4 1432",
    d: "M32.541,11.421a15.724,15.724,0,1,0,2.152,7.937,15.681,15.681,0,0,0-2.152-7.937m-.191,7.935a13.4,13.4,0,0,1-1.86,6.773A12.581,12.581,0,0,1,25.7,30.914a13.252,13.252,0,0,1-13.532,0,12.593,12.593,0,0,1-4.788-4.787,13.252,13.252,0,0,1,0-13.532,12.6,12.6,0,0,1,4.785-4.785h0a13.248,13.248,0,0,1,13.532,0A12.6,12.6,0,0,1,30.493,12.6a13.39,13.39,0,0,1,1.857,6.759",
    transform: "translate(1.061 1.202)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1433",
    "data-name": "\\uD328\\uC2A4 1433",
    d: "M21.774,11.988,14.805,18.9l-3.084-3.029A1.146,1.146,0,0,0,10.108,17.5L14,21.386l.007.005a1.2,1.2,0,0,0,.8.359,1.212,1.212,0,0,0,.811-.364L23.4,13.6a1.146,1.146,0,0,0-1.628-1.612",
    transform: "translate(3.248 3.875)",
    fill: "#23cdb7",
    opacity: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOff);
export default __webpack_public_path__ + "static/media/check-off.4be220754a229196c1c65faff5a247d8.svg";
export { ForwardRef as ReactComponent };